import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid} from '@material-ui/core';
import { SearchInput } from 'components';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  searchInput : {
    marginRight: theme.spacing(2),
    boxShadow: "inset 0 0 0 2px "
  }
}));

const ProductsToolbar = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  return (
  
        <Grid container alignItems="center" item xs={12} ms={4} lg={4} disable>
        <SearchInput   className={classes.searchInput}  placeholder="Search BookingTypes" />
        </Grid>
  );
};

export default ProductsToolbar;
